import React, { useEffect } from 'react'
import './AdSlot.css'

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT

let scriptLoaded = false
const loadAdSenseScript = (client) => {
  if (scriptLoaded || document.querySelector('script[data-adsbygoogle]')) {
    return
  }
  const script = document.createElement('script')
  script.async = true
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`
  script.crossOrigin = 'anonymous'
  script.dataset.adsbygoogle = 'true'
  document.head.appendChild(script)
  scriptLoaded = true
}

// Renders nothing until REACT_APP_ADSENSE_CLIENT is set (no account yet /
// pending approval), so the ad slot silently disappears rather than
// requesting a script that will fail.
const AdSlot = ({ slot, format = 'auto' }) => {
  useEffect(() => {
    if (!ADSENSE_CLIENT) return
    loadAdSenseScript(ADSENSE_CLIENT)
    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch {
      // adsbygoogle script may still be loading; safe to ignore
    }
  }, [])

  if (!ADSENSE_CLIENT) return null

  return (
    <div className="ad-slot">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  )
}

export default AdSlot
